import { Button, layouts as ButtonLayouts, IconPositions } from './src/Button';
import { ErrorMessage } from './src/ErrorMessage';
import { Checkbox } from './src/Checkbox';
import { Modal } from './src/Modal';
import { LayoutHandler } from './src/LayoutHandler';
import { Radio } from './src/Radio';
import { Field } from './src/Field';
import { Tag } from './src/Tag';
import { Box } from './src/Box';
import { Breadcrumbs } from './src/Breadcrumbs';
import { Select } from './src/Select';
import { Rating } from './src/Rating';
import { Slider, Layouts as SliderLayouts } from './src/Slider';
import { registerGlobal } from '@food/css-manager';
import { Icon } from './src/icons';
import { Modal as Modal2, ModalLayouts } from './src/Modal2';
import { Dropdown, DropdownPositions, DropdownAlignments, } from './src/Dropdown';
import { Collapsible, CollapsiblePhases } from './src/Collapsible';
import { Toggle } from './src/Toggle';
import { Tooltip } from './src/Tooltip';
// Varie impostazioni di base
registerGlobal(function (theme) { return "\n\thtml {\n\t\tcolor: " + theme.colors.ink + ";\n\t\t&, * {\n\t\t\tbox-sizing: border-box;\n\t\t\toutline: 0;\n\t\t}\n\t\t&, > body {\n\t\t\tmin-height: 100%;\n\t\t}\n\t}\n"; });
export { Button, IconPositions, ButtonLayouts, ErrorMessage, Checkbox, Modal, Radio, Tag, LayoutHandler, Field, Box, Breadcrumbs, Select, Rating, Slider, SliderLayouts, Icon, Dropdown, Collapsible, CollapsiblePhases, Toggle, Tooltip, DropdownPositions, DropdownAlignments, Modal2, ModalLayouts, };
//# sourceMappingURL=index.js.map